import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { ServiceComboItemType } from "@/Common/Models/Services/Enums/ServiceComboItemType";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { GenericCheckboxUIModel } from "@/Common/Models/UI/Inputs/GenericCheckboxUIModel";
import { LookupUIModel } from "@/Common/Models/UI/Inputs/LookupUIModel";

interface IServiceComboSearchSettingsProps {
    model: IServiceComboGridModel;
    id: string;
    className: string;
    refreshServiceCallBack: (s: IServiceComboGridModel, reload: boolean, closeSettings: boolean) => void;
    onOkCallBack: (s: IServiceComboGridModel) => void;
    onCancelCallBack: () => void;
}

class ServiceComboSearchSettingsState {
    public model: IServiceComboGridModel; // set a local copy of the model in state in order to manage the search settings control independently
}

class ServiceComboSearchSettings extends BaseReactComponent<IServiceComboSearchSettingsProps, ServiceComboSearchSettingsState> {
    private readonly helper: MyleHelper = new MyleHelper();

    constructor(props: IServiceComboSearchSettingsProps) {
        super(props);

        const initialState = new ServiceComboSearchSettingsState();
        initialState.model = props.model;
        this.state = initialState;
    }

    public componentDidMount(): void {
        super.setOverlay("ServiceComboSearchSettings", { transparent: true });
    }

    public render(): JSX.Element {
        let Specializations = this.state.model.get("Specializations").toArray();
        let specialtyFilteredAdHoc = Specializations.filter(x => x.Code != "Ad-HocSpe").toImmutable();

        return (
            <div id={this.props.id} className={this.props.className}>
                <table className="f-content">
                    <thead>
                        <tr>
                            {this.state.model.get("Sites").count() > 1 && (
                                <th><CheckboxControl
                                    id="sites_check"
                                    label={cacheStore.GetString("SitesLabel")}
                                    checked={this.state.model.get("Sites_AllSelected")}
                                    target={CheckboxTarget.Myle_Admin_ServiceCombo_Sites_AllCheck}
                                    onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                />
                                </th>
                            )}
                            <th>
                                <CheckboxControl
                                    id="speciality_check"
                                    label={cacheStore.GetString("SpecialityLabel")}
                                    checked={this.state.model.get("Specializations_AllSelected")}
                                    target={CheckboxTarget.Myle_Admin_ServiceCombo_Speciality_AllCheck}
                                    onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                />

                            </th>
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <th>
                                    <CheckboxControl
                                        id="type_check"
                                        label={cacheStore.GetString("TypeLabel")}
                                        checked={this.state.model.get("Types_AllSelected")}
                                        target={CheckboxTarget.Myle_Admin_ServiceCombo_Type_AllCheck}
                                        onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                    />
                                </th>
                            )}
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <th>
                                    <CheckboxControl
                                        id="employee_Check"
                                        label={cacheStore.GetString("EmployeeLabel")}
                                        checked={this.state.model.get("Employees_AllSelected")}
                                        target={CheckboxTarget.Myle_Admin_ServiceCombo_Employees_AllCheck}
                                        onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                    />
                                </th>
                            )}
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <th>
                                    <CheckboxControl
                                        id="status_Check"
                                        label={cacheStore.GetString("StatusLabel")}
                                        checked={this.state.model.get("Status_AllSelected")}
                                        target={CheckboxTarget.Myle_Admin_ServiceCombo_Status_AllCheck}
                                        onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                    />
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {this.props.model.get("Sites").count() > 1 && (
                                <td className="sites-column">
                                    <div style={{ maxHeight: "400px", minHeight: "400px", overflow: "auto" }}>
                                        <CheckedListControl
                                            DataSource={this.state.model.get("Sites")}
                                            onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                            MaxTextLength={27}
                                        />
                                    </div>

                                </td>
                            )}
                            <td>
                                <div style={{ maxHeight: "400px", overflow: "auto" }}>
                                    <CheckedListControl
                                        DataSource={specialtyFilteredAdHoc}
                                        onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                    />
                                </div>
                            </td>
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <td>
                                    <CheckedListControl
                                        DataSource={this.state.model.get("Types")}
                                        onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                    />
                                </td>
                            )}
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <td>
                                    <input
                                        className="form-control"
                                        style={{ width: "225px" }}
                                        type="text"
                                        value={this.state.model.get("EmployeesSearchText")}
                                        onChange={this.onSearchSettingsEmployeeFilterChange.bind(this)}
                                        placeholder={cacheStore.GetString("SearchLabel").toUpperCase()}
                                    />
                                    <div style={{ maxHeight: "400px", overflow: "auto" }}>
                                        <CheckedListControl
                                            DataSource={this.state.model.get("EmployeesFiltered")}
                                            onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                            sort={true}
                                            limitTextWidth={true}
                                            enableLazyRendering
                                        />
                                    </div>
                                </td>
                            )}
                            {this.props.id != "User_add_servicecombosettinggs" && (
                                <td>
                                    <div>
                                        <CheckboxControl
                                            id="status_active"
                                            label={cacheStore.GetString("IsActive")}
                                            onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                            checked={this.state.model.get("Status_IsActiveChecked")}
                                            target={CheckboxTarget.Myle_Admin_ServiceCombo_Status_ActiveCheck}
                                        />
                                    </div>
                                    <div>
                                        <CheckboxControl
                                            id="status_inactive"
                                            label={cacheStore.GetString("InactiveLabel").toTitleCase()}
                                            onChange={this.onSearchSettingsCheckedChanged.bind(this)}
                                            checked={this.state.model.get("Status_IsInactiveChecked")}
                                            target={CheckboxTarget.Myle_Admin_ServiceCombo_Status_InactiveCheck}
                                        />
                                    </div>
                                </td>
                            )}

                        </tr>
                    </tbody>
                </table>
                <div className="f-footer flex-container" style={{ justifyContent: "flex-end" }}>
                    <div className="text-right" style={{ display: "flex" }}>
                        <span className="push-right-5" style={{ marginRight: "20px", marginTop: "10px" }}>
                            <CheckboxControl
                                id="saveSettingsChecked"
                                checked={this.state.model.get("SaveDisplaySettings")}
                                onChange={(isChecked: boolean, id: string, target: number) => this.onSearchSettingsCheckedChanged(isChecked, id, target)}
                                label={cacheStore.GetString("RememberUserSettings")}
                                target={CheckboxTarget.Myle_Admin_Save_Display_Settings_Check}
                                DivWrap
                            />
                        </span>
                        <ButtonControl
                            className="btn btn-default push-right-5"
                            onClick={() => this.onCancelSearchSettings()}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            variant="brand"
                            onClick={() => this.onOkClick()}
                            label={cacheStore.GetString("Ok_Label")}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private applySearchSettings(model: IServiceComboGridModel): void {
        let sites = model.get("Sites").toArray();
        let specialities = AdministrationHelper.GetSpecializationsBasedOnSites(sites);
        let newEmployees = AdministrationHelper.GetEmployeesBasedOnSpecialization(model.get("EmployeesGlobalCache").toArray(), specialities);

        model = model.set("Specializations", Immutable.List(specialities));
        model = model.set("EmployeesFiltered", Immutable.List(newEmployees));
    }

    private onSearchSettingsCheckedChanged(checked: boolean, id: string, target: number): void {
        let model = this.state.model;

        switch (target) {
            case CheckboxTarget.Myle_Admin_ServiceCombo_Sites_AllCheck:
                {
                    model = model.set("Sites_AllSelected", checked);
                    model = model.set("Sites", this.helper.ChangeCheckStateFromAllICheckable(model.get("Sites"), checked));
                    this.applySearchSettings(model);
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Sites_Check:
                {
                    let newSites = this.helper.FindUpdateICheckableItem<SiteUIModel>(model.get("Sites"), id, checked);
                    model = model.set("Sites", newSites);
                    this.applySearchSettings(model);
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Speciality_AllCheck:
                {
                    model = model.set("Specializations_AllSelected", checked);
                    let newSpecialities = this.helper.ChangeCheckStateFromAllICheckable(model.get("Specializations"), checked);
                    model = model.set("Specializations", newSpecialities);
                    let newEmployees = AdministrationHelper.GetEmployeesBasedOnSpecialization(model.get("EmployeesGlobalCache").toArray(), newSpecialities.toArray());
                    model = model.set("EmployeesFiltered", Immutable.List(newEmployees));
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Speciality_Check:
                {
                    let newSpecialities = this.helper.FindUpdateICheckableItem<LookupUIModel>(model.get("Specializations"), id, checked);
                    model = model.set("Specializations", newSpecialities);
                    let newEmployees = AdministrationHelper.GetEmployeesBasedOnSpecialization(model.get("EmployeesGlobalCache").toArray(), newSpecialities.toArray());
                    model = model.set("EmployeesFiltered", Immutable.List(newEmployees));
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Type_AllCheck:
                {
                    model = model.set("Types_AllSelected", checked);
                    model = model.set("Types", this.helper.ChangeCheckStateFromAllICheckable(model.get("Types"), checked));
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Type_Check:
                {
                    let newTypes = this.helper.FindUpdateICheckableItem<GenericCheckboxUIModel<ServiceComboItemType>>(model.get("Types"), id, checked);
                    model = model.set("Types", newTypes);
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Employees_AllCheck:
                {
                    model = model.set("Employees_AllSelected", checked);
                    model = model.set("EmployeesFiltered", this.helper.ChangeCheckStateFromAllICheckable(model.get("EmployeesFiltered"), checked));
                }
                break;

            case CheckboxTarget.Myle_Admin_ServiceCombo_Employees_Check:
                {
                    let newEmployees = this.helper.FindUpdateICheckableItem<EmployeeUIModel>(model.get("EmployeesFiltered"), id, checked).toArray();
                    newEmployees = AdministrationHelper.GetEmployeesBasedOnSpecialization(newEmployees, model.get("Specializations").toArray());
                    model = model.set("EmployeesFiltered", Immutable.List(newEmployees));
                }
                break;
            case CheckboxTarget.Myle_Admin_ServiceCombo_Status_AllCheck:
                {
                    model = model.set("Status_IsActiveChecked", checked);
                    model = model.set("Status_IsInactiveChecked", checked);
                    model = model.set("Status_AllSelected", checked);
                }
                break;
            case CheckboxTarget.Myle_Admin_ServiceCombo_Status_ActiveCheck:
                {
                    model = model.set("Status_IsActiveChecked", checked);
                }
                break;
            case CheckboxTarget.Myle_Admin_ServiceCombo_Status_InactiveCheck:
                {
                    model = model.set("Status_IsInactiveChecked", checked);
                }
                break;
            case CheckboxTarget.Myle_Admin_Save_Display_Settings_Check:
                {
                    model = model.set("SaveDisplaySettings", checked);
                }
                break;

            default:
                break;
        }

        this.mutateState(
            s => {
                s.model = model;
            },
            () => { this.refreshGrid(); }
        );
    }

    private onSearchSettingsEmployeeFilterChange(e: React.ChangeEvent<HTMLInputElement>): void {
        let val = e.target.value;
        this.mutateState(s => {
            s.model = this.state.model.set("EmployeesSearchText", val);
            s.model = this.applyEmployeeTextFilter(s.model);
        });
    }

    private applyEmployeeTextFilter(model: IServiceComboGridModel): IServiceComboGridModel {
        let allEmployees = model.get("EmployeesGlobalCache");
        let filterString = $.trim(model.get("EmployeesSearchText"));
        if (filterString !== "") {
            allEmployees = SearchMenuHelper.FilterCliniciansByName(filterString, allEmployees);
        }
        return model = model.set("EmployeesFiltered", allEmployees);
    }

    private onOkClick(): void {
        this.props.onOkCallBack(this.state.model);
    }

    private refreshGrid(): void {
        this.props.refreshServiceCallBack(this.state.model, false, false);
    }

    private onCancelSearchSettings(): void {
        this.props.onCancelCallBack();
    }
}

export { ServiceComboSearchSettings };
